module.exports = __webpack_public_path__ + "static/img/3.a6cbae4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/Nya/3.jpg
// module id = 1/qK
// module chunks = 0